import React, { useState, useEffect } from "react";
import ListTable from "./ListTable";
import CardList from "./CardList";
import ColumnsModal from "./ColumnsModal"; // Подключаем модальное окно колонок

const DataTable = ({
  data = [], // Дефолтное значение пустой массив
  config,
  viewMode,
  onDelete,
  onRestore, // Добавляем onRestore
  onToolbarData,
  selectedItems: controlledSelectedItems,
  onPermanentDelete,
  actions = [], // Указываем значение по умолчанию как массив
  renderCardActions,
  onCopy, // <-- Добавили!
  navigate, // <-- Добавлено!
  sortField: externalSortField, // Внешнее управление сортировкой
  sortOrder: externalSortOrder,
  onSort: externalOnSort,
  highlightedRowId = null, // ID строки для подсветки после возврата
  tableKey = "table", // Ключ таблицы для формирования id строк
}) => {
  const [internalSortField, setInternalSortField] = useState(null);
  const [internalSortOrder, setInternalSortOrder] = useState("asc");
  const [internalSelectedItems, setInternalSelectedItems] = useState([]);
  const selectedItems = controlledSelectedItems ?? internalSelectedItems;
  const setSelectedItems = (value) => {
    const next = typeof value === 'function' ? value(selectedItems) : value;
    if (controlledSelectedItems !== undefined) {
      onToolbarData?.({ selectedItems: next });
    } else {
      setInternalSelectedItems(next);
    }
  };
  const [isColumnsModalOpen, setIsColumnsModalOpen] = useState(false); // Состояние для модального окна
  const [selectedColumns, setSelectedColumns] = useState(
    config.map((col) => col.field) // Изначально включаем все колонки
  );

  // Используем внешнее состояние сортировки если оно передано, иначе внутреннее
  const sortField = externalSortField !== undefined ? externalSortField : internalSortField;
  const sortOrder = externalSortOrder !== undefined ? externalSortOrder : internalSortOrder;

  // Сортировка данных (только если нет внешнего управления)
  const sortedData = externalOnSort 
    ? data // Если есть внешний обработчик, данные уже отсортированы
    : [...data].sort((a, b) => {
        if (!sortField) return 0;
        const aValue = a[sortField] !== undefined ? String(a[sortField]) : "";
        const bValue = b[sortField] !== undefined ? String(b[sortField]) : "";

        return sortOrder === "asc"
          ? aValue.localeCompare(bValue, undefined, { numeric: true })
          : bValue.localeCompare(aValue, undefined, { numeric: true });
      });

  // Обновляем Toolbar данными
  useEffect(() => {
    if (onToolbarData && controlledSelectedItems === undefined) {
      onToolbarData({
        selectedItems,
        onDeleteSelected: handleDeleteSelected,
      });
    }
  }, [selectedItems]);

  // Удаление выбранных строк
  const handleDeleteSelected = () => {
    console.log("Удаление выбранных:", selectedItems);
  };

  const handleSort = (field) => {
    if (externalOnSort) {
      // Если есть внешний обработчик, используем его
      externalOnSort(field);
    } else {
      // Иначе используем внутреннее состояние
      if (sortField === field) {
        setInternalSortOrder(internalSortOrder === "asc" ? "desc" : "asc");
      } else {
        setInternalSortField(field);
        setInternalSortOrder("asc");
      }
    }
  };

  const handleSelectAll = () => {
    if (sortedData.every(item => selectedItems.includes(item.id))) {
      setSelectedItems([]);
    } else {
      setSelectedItems(sortedData.map((item) => item.id));
    }
  };

  const handleSelectItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };

  // Обработчик изменений колонок
  useEffect(() => {
    if (config.length > 0) {
      setSelectedColumns(config.map((col) => col.field)); // Обновляем выбранные колонки
    }
  }, [config]);


  // Режим "list" и динамическое создание колонок
  if (viewMode === "list") {
    return (
      <>
        <ListTable
          data={sortedData}
          config={config.filter((col) => selectedColumns.includes(col.field))} // Фильтруем по выбранным колонкам
          sortField={sortField}
          sortOrder={sortOrder}
          onSort={handleSort}
          selectedItems={selectedItems}
          onSelectItem={handleSelectItem}
          onSelectAll={handleSelectAll}
          actions={actions} // Передаём массив действий
          handlers={{
            onDelete,
            onRestore,
            onPermanentDelete,
            onCopy, // <-- Добавили!
            navigate, // <-- Добавлено!
          }} // Передаём обработчики как отдельный объект
          highlightedRowId={highlightedRowId}
          tableKey={tableKey}
        />
      </>
    );
  }

  // Режимы "module" и "apps"
  if (viewMode === "module" || viewMode === "apps") {
    return (
      <CardList
        renderActions={renderCardActions}
        data={sortedData}
        config={config.filter(col => selectedColumns.includes(col.field))}
        viewMode={viewMode}
        onDelete={onDelete}
        onRestore={onRestore} // Добавляем функцию восстановления
        selectedItems={selectedItems}
        onSelectItem={handleSelectItem}
        onSelectAll={handleSelectAll}
      />
    );
  }

  return null;
};

export default DataTable;
